<template>
  <div class="locale-switcher big mbs">
    <span :class="{ active: $i18n.locale === 'de' }" @click="switchLocale('de')"
      >de</span
    >/<span
      :class="{ active: $i18n.locale === 'en' }"
      @click="switchLocale('en')"
      >en</span
    >
  </div>
</template>

<script>
export default {
  methods: {
    switchLocale(locale) {
      if (locale !== this.$i18n.locale) {
        this.$i18n.locale = locale;
        this.$router.push({
          name: "default",
          params: {
            lang: locale
          }
        });
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.locale-switcher {
  padding-right: var(--lh);
  span {
    cursor: pointer;
    display: inline-block;
    border-bottom: var(--b) solid transparent;
    &:hover {
      border-bottom: var(--b) solid var(--color);
    }
  }
}
</style>
